import React, { useEffect, useState } from "react";
import Logo from "assets/Logo.png";
import { Button, Card } from "react-bootstrap";

export default function PreviewProfile() {
  const [clientimage, setClientimage] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [client, setClient] = useState([]);
  const [image, setImage] = useState([]);

  useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).data.token,
      },
    };
    fetch(
      `${BASE_URL}/client/listclientsetting/${
        JSON.parse(sessionStorage.getItem("token")).data.clientuserid
      }`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        setClient(response.data.listClientUsersSetting[0]);
        setImage(response.data.listClientUsersSetting);
        // console.log(response.data.listClientUsersSetting);
      });
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-lg-4 col-sm-4 col-xs-4 grid-margin">
          <div className="card card-left ">
            <div className="card-body" style={{ marginTop: -9 }}>
              <div className="row">
                <div className="col-lg-12 grid-margin text-center">
                  {image.map((meg) => (
                    <img
                      width={222}
                      height={222}
                      className=" ml-auto rounded-circle "
                      src={require(`assets/images/faces/${meg.imageurl}`)}
                      alt="{client.imageid}"
                    />
                  ))}
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-8">
          <Card>
            <Card.Body>
              <Card.Title style={{ fontSize: 22 }}> Evenglos</Card.Title>
              <h4 className="float-right">New York</h4>
              <br />
              <h6 className="mt-2">Massage Specialist</h6>
              {/* <img
            src={IMG}
            style={{ height: "100%", width: "100%" }}
            alt="promotion"
          /> */}
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </p>
              <Card.Link href="/offers/offers"></Card.Link>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 col-sm-4 col-xs-4 grid-margin">
          <div className="card card-left ">
            <div className="card-body" style={{ marginTop: -9 }}>
              <div className="row">
                <div className="col-lg-12 grid-margin ">
                  <hr />
                  <h6>Massage New York</h6>
                  <p>dummy address dummy address dummy address</p>
                  <hr />
                  <h6>Massage New York</h6>
                  <p>dummy address dummy address dummy address</p>
                  <hr />
                  <h6>Massage New York</h6>
                  <p>dummy address dummy address dummy address</p>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-8 col-sm-8 col-xs-8">
          <div className="card card-left">
            <div className="card-body">
              <h4 className="card-title mt-2">Account Details </h4>
              <div className="row mt-5">
                <div
                  className="col-lg-4 col-sm-4 col-xs-4"
                  style={{ fontSize: 12 }}
                >
                  <b>Full Name:</b>{" "}
                </div>
                <div className="col-lg-8 col-sm-8 col-xs-8">
                  <p>
                    {client.client_name} {client.last_name}
                  </p>{" "}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4" style={{ fontSize: 12 }}>
                  <b>Email Address:</b>{" "}
                </div>
                <div className="col-lg-8">
                  <p>{client.email}</p>{" "}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4" style={{ fontSize: 12 }}>
                  <b>Mobile Phone:</b>{" "}
                </div>
                <div className="col-lg-8">
                  <p>{client.mobile_phone}</p>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4" style={{ fontSize: 12 }}>
                  <b>Company Name:</b>{" "}
                </div>
                <div className="col-lg-8">
                  <p>{client.companyname}</p>{" "}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4" style={{ fontSize: 12 }}>
                  <b>Location:</b>{" "}
                </div>
                <div className="col-lg-8">
                  <p>{client.state}</p>{" "}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4" style={{ fontSize: 12 }}>
                  <b>Address:</b>{" "}
                </div>
                <div className="col-lg-8">
                  <p>{client.address}</p>{" "}
                </div>
              </div>
            </div>
          </div>
            </div>
      </div>
    </>
  );
}
